import React, { useState, useEffect } from 'react';

import 'assets/scss/tags_select.scss';
import { Cancel } from '@material-ui/icons';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import BeSafeButton from './BeSafeButton';

const BeSafeMultiInput = (props) => {
  const [inputValue, setInputValue] = useState('');
  const [selectedItems, setSelectedItems] = useState(props.selectedItems || []);

  const removeItems = (indexToRemove) => {
    setSelectedItems([
      ...selectedItems.filter((_, index) => index !== indexToRemove),
    ]);

    props.onChange([
      ...selectedItems.filter((_, index) => index !== indexToRemove),
    ]);
  };

  const onItemChange = (items) => {
    setSelectedItems(items);

    props.onChange(items);
  };

  const onAddTag = (inputValue) => {
    if (inputValue.length > 0) {
      onItemChange([...selectedItems, inputValue]);
      setInputValue('');
    }
  };

  const handleTab = (e) => {
    const textValue = e.target.value;
    onAddTag(textValue);
  };

  const clearItems = () => {
    setSelectedItems([]);
  };

  useEffect(() => {
    if (!props.selectedItems) {
      clearItems();
    }
  }, [props.selectedItems]);

  return (
    <>
      <div className="d-flex flex-column">
        <div className="d-flex mb-2">
          <ul id="tags">
            {selectedItems.map((item, index) => (
              <li key={index} className="tag">
                <span className="ellipsable">{props.formatName(item)}</span>
                <Cancel
                  className="ml-1 tag-button"
                  onClick={() => removeItems(index)}
                />
              </li>
            ))}
          </ul>
        </div>
        <div className="d-flex">
          <div className="tags-select">
            <input
              type="text"
              className="border-secondary form-control p-2"
              placeholder={props.placeholder}
              disabled={!props.inputEnabled}
              onChange={(e) => setInputValue(e.target.value)}
              value={inputValue}
              onKeyDown={(e) => {
                if (e.key.match(/^(Tab|Enter)$/)) {
                  e.preventDefault();
                  handleTab(e);
                }
              }}
            />
          </div>
          <BeSafeButton
            variant="transparent"
            className="py-0 ml-auto pl-1 pr-0"
            onClick={() => onAddTag(inputValue)}
            icon={<AddCircleOutlineIcon />}
            tooltip={
              props.filterType === 'src_ip'
                ? `FILTERS.ADD_MULTI_INPUT.${props.filterType.toUpperCase()}`
                : 'GENERAL.ADD_MULTI_INPUT'
            }
          />
        </div>
      </div>
    </>
  );
};

BeSafeMultiInput.defaultProps = {
  onChange: () => {},
  formatName: (a) => a,
};

export default BeSafeMultiInput;
